module.exports = __webpack_public_path__ + "svg/chevron-down-thick.f360c82b4cebdc527a066792a1ebc78d.svg";